import React, { useEffect } from 'react';
import { useEventTracker } from "./useEventTracker";
export function useTrackViewEvent(_ref) {
  var event = _ref.event,
    data = _ref.data;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var didTrackRef = React.useRef(false);
  useEffect(function () {
    if (!didTrackRef.current) {
      var viewEvent = {
        event: event
      };
      if (data) viewEvent.data = data;
      trackEvent(viewEvent);
      didTrackRef.current = true;
    }
  }, [trackEvent, event, data]);
}